export const APP_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;

export const isDev = () => APP_ENV === "development";
export const isProd = APP_ENV === "production";

export const JUNE_SO_WRITEKEY = process.env.NEXT_PUBLIC_JUNE_SO_WRITEKEY;
export const MIXPANEL_API_KEY = process.env.NEXT_PUBLIC_MIXPANEL_API_KEY;

export const CLARITY_API_KEY = process.env.NEXT_PUBLIC_CLARITY_API_KEY || "";
